export const TEST_ID = 'lifecycleMenu';
